import { useEffect, useRef } from 'react'

export default function useSmall({
  children,
  itemWidth,
  gap = 4,
  margin = 0,
  outerPadding = 0,
  startWithItem,
}: {
  children: React.ReactNode | React.ReactNode[]
  itemWidth: number
  gap?: number
  margin?: number
  outerPadding?: number
  startWithItem?: number
}) {
  const scrollContainer = useRef<HTMLDivElement>(null)
  const items = Array.isArray(children) ? children : [children]
  const gapPx = gap * 4
  const containerWidth =
    itemWidth * items.length +
    gapPx * (items.length - 1) +
    margin * 8 +
    outerPadding * 8
  useEffect(() => {
    if (scrollContainer?.current.scrollLeft === 0 && startWithItem) {
      scrollContainer.current.scrollTo(startWithItem * (itemWidth + gap * 4), 0)
    }
  }, [gap, itemWidth, scrollContainer, startWithItem])
  return { containerWidth, scrollContainer, items }
}
